<template>
  <div class="content locations" :class="{ 'is-staff': isStaff }">
    <div class="container-fluid">
      <div class="row" v-for="i in rowCount" v-bind:key="i">
        <div class="col-sm">
          <location-card
            :ref="'location-ref-'+advertisers[(i * 2) - 2].name+'-'+advertisers[(i * 2) - 2].location"
            :location="advertisers[(i * 2) - 2]"  
            @click.native="onLocationSelected((i * 2) - 2)"
            :class="{ selected: isIndexSelected((i * 2) - 2) }" />
        </div>
        <div class="col-sm">
          <location-card 
            v-if="(i * 2) <= advertisers.length"
            :ref="'location-ref-'+advertisers[(i * 2) - 1].name+'-'+advertisers[(i * 2) - 1].location"
            :location="advertisers[(i * 2) - 1]"
            @click.native="onLocationSelected((i * 2) - 1)"
            :class="{ selected: isIndexSelected((i * 2) - 1) }" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LocationCard from '@/components/UIComponents/Cards/LocationCard.vue'

  export default {
    components: {
      LocationCard,
    },
    data: function () {
      return {
        itemsPerRow: 2,
        selected_index: 0,
      }
    },
    computed: {
      rowCount () {
        return Math.ceil(this.advertisers.length / this.itemsPerRow);
      },
      advertiser () {
        return this.$store.getters.advertiser;
      },
      advertisers () {
        return this.$store.getters.university_advertisers(this.$store.getters.university.id);
      },
      isStaff () {
        return this.$store.getters.user.is_staff;
      }
    },
    methods: {
      async onLocationSelected (index) {
        this.$store.dispatch('setAdvertiser', this.advertisers[index])
        if (this.$store.getters.rewards.length === 0) {
          await this.$store.dispatch('obtainAdvertiser', this.advertiser.id)
        }
        this.$router.push('/analytics')
      },
      isIndexSelected (index) {
        return this.advertisers[index].id === this.advertiser.id
      },
      scrollToSelectedLocationCard () {
        let current_card = this.$refs['location-ref-' + this.advertiser.name + '-' + this.advertiser.location];
        var new_offset = current_card[0].$el.parentElement.offsetTop + current_card[0].$el.offsetTop - 30;
        if (this.isStaff) {
          new_offset = new_offset - 80;
        }

        this.$nextTick(() => {
          this.$emit('scrollTop', new_offset);
        });
      }
    },
    mounted () {
      this.scrollToSelectedLocationCard();
    }
  }
</script>
